import React from 'react';
import {TextInput} from 'react-admin';

const VersionInput = props => <TextInput disabled={true} source={props.source || "version"} style={{display: 'none'}} {...props} />;

export default VersionInput
